import { render, staticRenderFns } from "./WorkLocationsCMD.vue?vue&type=template&id=47b31400&scoped=true&"
import script from "./WorkLocationsCMD.vue?vue&type=script&lang=js&"
export * from "./WorkLocationsCMD.vue?vue&type=script&lang=js&"
import style0 from "./WorkLocationsCMD.vue?vue&type=style&index=0&id=47b31400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b31400",
  null
  
)

export default component.exports